import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group/tile bg-text-main-inversion relative z-0 flex w-full flex-col overflow-hidden p-2 max-md:pb-4 md:p-4',
    link: 'absolute inset-0 z-100 cursor-pointer',
    imageContainer: 'relative w-full',
    imageWrapper: 'relative h-full w-full bg-white max-xl:min-h-[192px]',
    image: 'aspect-[303/324] h-full w-full object-contain',
    labels:
      'absolute -top-2 -left-2 flex max-w-[180px] flex-wrap gap-1 max-md:right-8 md:-top-4 md:-left-4',
    productOverlay: 'product-overlay',
    checkbox: 'absolute bottom-0 left-0 z-101',
    outOfStockLabel:
      'absolute top-1/2 left-1/2 z-20 z-101 -translate-x-1/2 -translate-y-1/2 transform font-medium',

    content: 'mt-6 flex flex-1 flex-col md:mt-4.5',
    header: 'relative flex items-center justify-between',
    brandContainer: 'relative z-20',
    options: 'relative z-20',
    rating:
      'heading-xs md:heading-s -top-8 flex items-center gap-1.5 rounded-full bg-white px-2 max-md:absolute',
    starIcon: 'text-icon-star size-4',
    info: '',
    title:
      'max-xl:heading-xs min-xl:heading-l-strikethrough line-clamp-2 text-base font-normal max-xl:min-h-10 xl:min-h-13.5',
    description:
      'md:heading-s heading-xs mt-1 line-clamp-2 min-h-10 md:min-h-12',
    bottom: 'mt-0 flex flex-col gap-1 md:mt-5 md:gap-0',
    actions: 'relative z-20 z-101 mt-1 flex flex-col gap-1 md:mt-0',
    actionButton: '',
    buttonBuyPrice: 'max-md:items-start max-md:gap-1 max-md:p-0',
    buttonBuyPriceValue: '',
    buttonBuyPriceOldValue: '',
    wishlist:
      'absolute top-0 right-0 z-101 size-6 group-hover/tile:opacity-100 md:size-8 md:opacity-0',
    compare:
      'absolute top-8 right-0 z-101 size-6 cursor-pointer group-hover/tile:opacity-100 md:top-10 md:size-8 md:opacity-0',
    compareIcon: 'hover:[&>path]:stroke-icon-brand h-full w-full',
    button: 'z-101 size-[48px] max-xl:absolute max-xl:right-0 max-xl:-bottom-5'
  },
  variants: {
    wishlist: {
      true: {
        wishlist: 'md:opacity-100',
        rating: 'md: -top-6 right-0 left-0 md:-top-[30px]'
      },
      false: {
        rating: '-top-[30px] left-0'
      }
    },
    type: {
      base: {
        buttonBuyPriceValue: ''
      },
      search: {
        buttonBuyPriceValue: ''
      }
    },
    compare: {
      true: {
        compare: 'md:opacity-100'
      }
    },
    withSelect: {
      true: {
        imageWrapper: 'max-md:min-h-[192px] xl:min-h-[232px]',
        content: 'md:mt-4',
        bottom: 'md:mt-0',
        title:
          'min-xl:heading-s min-xl:min-h-10 xl:min-h-10 min-xl:leading-[140%]',
        buttonBuyPrice: 'gap-3',
        buttonBuyPriceValue: 'xl:text-xs xl:leading-[140%]',
        buttonBuyPriceOldValue: 'xl:text-xs xl:leading-[140%]',
        actions: 'mt-1.5 md:mt-1.5',
        compare: 'opacity-100 md:opacity-100'
      }
    }
  },
  defaultVariants: {
    wishlist: false,
    type: 'base',
    compare: false
  }
});
